<template>
  <v-list style="background-color: transparent">
    
    <v-list-item v-for="(item, index) in menuItems" :key="index" :to="item.to">
      <div
        class="d-flex align-center justify-center"
        :style="{
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          backgroundColor: item.bgColor,
          marginRight: '16px',
          flexShrink: 0
        }"
      >
        <img
          :src="item.icon"
          style="width: 18px; height: 18px; object-fit: contain; display: block"
        />
      </div>
      <v-list-item-content class="defaultColor--text"> {{item.title}} </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  data: function () {
    {
      return {
        menuItems: [
          {
            icon: require('@/assets/QuickMenu/birth.svg').default || require('@/assets/QuickMenu/birth.svg'),
            bgColor: '#FF9400',
            to: "/bornTodayUsers",
            title: this.$t('menu.bornToday'),
          },
          {
            icon: require('@/assets/QuickMenu/newJoin.svg').default || require('@/assets/QuickMenu/newJoin.svg'),
            bgColor: '#0051A4',
            to: "/newComers",
            title: this.$t('menu.newComers'),
          },
          {
            icon: require('@/assets/QuickMenu/most.svg').default || require('@/assets/QuickMenu/most.svg'),
            bgColor: '#3F0089',
            to: "/bestOfUsers",
            title: this.$t('menu.bestOfBSP'),
          },
          {
            icon: require('@/assets/QuickMenu/thanks.svg').default || require('@/assets/QuickMenu/thanks.svg'),
            bgColor: '#FFD100',
            to: "/thanksForm",
            title: this.$t('menu.thanks'),
          },
          {
            icon: require('@/assets/QuickMenu/survey.svg').default || require('@/assets/QuickMenu/survey.svg'),
            bgColor: '#B1007C',
            to: "/surveyList",
            title: this.$t('menu.surveys'),
          },
        ],
      };
    }
  },
  props: {},
  mounted() {},
  methods: {},
  computed: {},
};
</script>
